module.exports = __webpack_public_path__ + "static/media/image.2b874282.png";